import { CARRIER_MANAGEMENT } from "api/ApiPath";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { CarrierRequestModel } from "./model/CarrierRequestModel";
import { CarrierResponseModel } from "./model/CarrierResponseModel";

export interface ICarrierRepository {
  getList(
    params: CarrierRequestModel
  ): Promise<ListBaseApiResponseModel<CarrierResponseModel>>;
}

@injectable()
export class CarrierImpl implements ICarrierRepository {
  async getList(
    params: CarrierRequestModel
  ): Promise<ListBaseApiResponseModel<CarrierResponseModel>> {
    return await client?.get(CARRIER_MANAGEMENT.LIST, params);
  }
}
